module.exports = __webpack_public_path__ + "static/media/satelite-image.c8f26683.png";